<template>
  <a v-if="parsed" :href="parsed.rfc3966">
    {{ $texts('storefinder.telephone', 'Tel') }}:
    {{ parsed.international }}
  </a>
  <div v-else-if="value">
    {{ $texts('storefinder.telephone', 'Tel') }}:
    {{ value }}
  </div>
</template>

<script lang="ts" setup>
import { type FieldItemTypeTelephoneFragment } from '#graphql-operations'

defineProps<{
  parsed?: FieldItemTypeTelephoneFragment['parsed']
  value?: FieldItemTypeTelephoneFragment['value']
}>()

const { $texts } = useNuxtApp()
</script>
